import { FC, useEffect, useState } from 'react';
import { Image, Text, TouchableOpacity, View } from 'react-native';
import { COLORS, FONTS } from '../../../constants';
import { SCREEN_WITDH } from '../../../constants/platform';
import EnhancedImageViewing from 'react-native-image-viewing';
import RenderHTML from 'react-native-render-html';

interface ReceiveMessageProps {
  content?: string;
  time: string;
  type?: 'text' | 'image';
  media?: {
    id: number;
    name: string;
    original_url: string;
    image_sizes: {
      height: number;
      width: number;
    };
  }[];
}

const ReceiveMessage: FC<ReceiveMessageProps> = ({
  content,
  time,
  type = 'text',
  media = [],
}) => {
  const [imageW, setImageW] = useState<number>(1);
  const [imageH, setImageH] = useState<number>(1);
  const [visible, setIsVisible] = useState<boolean>(false);

  useEffect(() => {
    if (type === 'image' && media.length > 0) {
      Image.getSize(media[0].original_url, (w, h) => {
        setImageW(w);
        setImageH(h);
      });
    }
  }, [media, type]);

  return (
    <View
      style={{
        flexDirection: 'row',
        justifyContent: 'flex-start',
        paddingVertical: 15,
      }}
    >
      <View style={{ position: 'relative' }}>
        <View
          style={{
            width: 0,
            height: 0,
            borderLeftWidth: 40,
            borderRightWidth: 0,
            borderTopWidth: 20,
            borderLeftColor: 'transparent',
            borderRightColor: 'transparent',
            borderTopColor: 'white',
            position: 'absolute',
            bottom: 0,
          }}
        ></View>
        <Text
          style={{
            fontFamily: FONTS.AvenirMedium,
            fontWeight: '500',
            fontSize: 8,
            color: COLORS.GREY,
            bottom: 0,
            right: 10,
            position: 'absolute',
            zIndex: 4,
          }}
        >
          {time}
        </Text>
        <View
          style={{
            backgroundColor: COLORS.WHITE,
            padding: 10,
            borderRadius: 16,
            marginLeft: 20,
            minWidth: 50,
          }}
        >
          {type === 'image' && media.length > 0 ? (
            <TouchableOpacity
              onPress={() => {
                setIsVisible(true);
              }}
            >
              <Image
                source={{ uri: media[0].original_url }}
                style={{
                  width: Math.min(SCREEN_WITDH / 2, media[0].image_sizes.width),
                  height:
                    Number(
                      Math.min(SCREEN_WITDH / 2, media[0].image_sizes.width) *
                        (media[0].image_sizes.height /
                          media[0].image_sizes.width)
                    ) ?? 0,
                  resizeMode: 'contain',
                  marginBottom: 5,
                }}
              />
            </TouchableOpacity>
          ) : (
            <View style={{ maxWidth: 300 }}>
              <RenderHTML
                source={{ html: content ?? '' }}
                tagsStyles={{
                  body: {
                    marginTop: 0,
                    color: COLORS.GREY,
                    fontWeight: '500',
                    marginBottom: 0,
                    fontFamily: FONTS.AvenirMedium,
                    fontSize: 16,
                  },
                }}
              />
            </View>
          )}
        </View>
      </View>
      {/* Disable on website */}
      {/* {type === 'image' && media.length > 0 && (
        <EnhancedImageViewing
          images={[{ uri: media[0].original_url }]}
          imageIndex={0}
          visible={visible}
          onRequestClose={() => setIsVisible(false)}
          swipeToCloseEnabled={true}
        />
      )} */}
    </View>
  );
};

export default ReceiveMessage;
